/**
 * YLI GA4 Thread Matchmaker Tracking
 * Version: 1.0.0
 * Created: 2026-01-14
 * Purpose: Track Thread Matchmaker technique selection clicks
 * GA4 Events: thread_matchmaker_click, thread_matchmaker_browse_all_click
 * Spec: docs/ga4-events/ga4-event-tracking-plan.md
 */

(function() {
  'use strict';

  // GA4 Event: thread_matchmaker_click
  // Track when users click technique buttons (Appliqué, Longarm, etc.)
  function trackThreadMatchmakerClick() {
    document.addEventListener('click', function(e) {
      var techniqueButton = e.target.closest('[data-matchmaker-technique]');
      if (!techniqueButton) return;

      var technique = techniqueButton.getAttribute('data-matchmaker-technique');
      var destinationUrl = techniqueButton.getAttribute('data-matchmaker-url') || '';

      // Determine page context
      var pageType = 'unknown';
      var pageUrl = window.location.pathname;

      if (pageUrl === '/' || pageUrl === '/index') {
        pageType = 'homepage';
      } else if (pageUrl.includes('/pages/')) {
        pageType = 'page';
        // Extract page handle from URL
        var pageHandle = pageUrl.split('/pages/')[1]?.split('?')[0] || '';
        if (pageHandle) {
          pageType = 'page:' + pageHandle;
        }
      } else if (pageUrl.includes('/collections/')) {
        pageType = 'collection';
      } else if (pageUrl.includes('/products/')) {
        pageType = 'product';
      }

      if (typeof gtag === 'function') {
        gtag('event', 'thread_matchmaker_click', {
          'technique_selected': technique,
          'destination_url': destinationUrl,
          'page_type': pageType,
          'page_url': pageUrl
        });
      }
    });
  }

  // GA4 Event: thread_matchmaker_browse_all_click
  // Track when users click "Browse all thread collections" escape link
  function trackBrowseAllClick() {
    document.addEventListener('click', function(e) {
      var escapeLink = e.target.closest('[data-matchmaker-escape="true"]');
      if (!escapeLink) return;

      var linkText = escapeLink.getAttribute('data-matchmaker-escape-text') || 'Browse all thread collections';
      var destinationUrl = escapeLink.getAttribute('href') || '';

      // Determine page context
      var pageType = 'unknown';
      var pageUrl = window.location.pathname;

      if (pageUrl === '/' || pageUrl === '/index') {
        pageType = 'homepage';
      } else if (pageUrl.includes('/pages/')) {
        var pageHandle = pageUrl.split('/pages/')[1]?.split('?')[0] || '';
        pageType = pageHandle ? 'page:' + pageHandle : 'page';
      } else if (pageUrl.includes('/collections/')) {
        pageType = 'collection';
      } else if (pageUrl.includes('/products/')) {
        pageType = 'product';
      }

      if (typeof gtag === 'function') {
        gtag('event', 'thread_matchmaker_browse_all_click', {
          'link_text': linkText,
          'destination_url': destinationUrl,
          'page_type': pageType,
          'page_url': pageUrl
        });
      }
    });
  }

  // Initialize tracking when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackThreadMatchmakerClick();
      trackBrowseAllClick();
    });
  } else {
    trackThreadMatchmakerClick();
    trackBrowseAllClick();
  }

})();
